import { Directive, ElementRef, Input } from '@angular/core';

@Directive({
    selector: '[setVideoStartEnd]',
    standalone: false
})
export class SetVideoStartEndDirective {

    @Input('setVideoStartEnd') breakpoints: string[];

    private videoStart: number;
    private videoEnd: number;
    private originalVideoUrl: string;
    private timeUpdateListener: any;
    private playListener: any;

    constructor(private el: ElementRef) { }

    ngAfterViewInit(): void {
        const videoElement = this.el.nativeElement as HTMLVideoElement;

        this.originalVideoUrl = this.getCleanVideoUrl(videoElement);

        this.playListener = this.onPlay.bind(this);
        videoElement.addEventListener('play', this.playListener);

        this.videoStart = this.mapTimeStamp(this.breakpoints[0]);
        this.videoEnd = this.mapTimeStamp(this.breakpoints[1]);
    }

    ngOnDestroy(): void {
        const videoElement = this.el.nativeElement as HTMLVideoElement;
        if (this.timeUpdateListener) {
            videoElement.removeEventListener('timeupdate', this.timeUpdateListener);
        }
        if (this.playListener) {
            videoElement.removeEventListener('play', this.playListener);
        }
    }

    private getCleanVideoUrl(video: HTMLVideoElement): string {
        let url = video.currentSrc || video.src;
        if (url) {
            url = url.split('#')[0];
        }
        return url;
    }

    onPlay(): void {
        const video = this.el.nativeElement as HTMLVideoElement;

        if (this.timeUpdateListener) {
            video.removeEventListener('timeupdate', this.timeUpdateListener);
        }

        this.timeUpdateListener = () => {
            if (video.currentTime >= this.videoEnd) {
                video.pause();
            }
        };
        video.addEventListener('timeupdate', this.timeUpdateListener);

        if (video.currentTime < this.videoStart || video.currentTime >= this.videoEnd) {
            const newUrl = `${this.originalVideoUrl}#t=${this.videoStart},${this.videoEnd}`;

            video.src = newUrl;
            video.load();

            video.addEventListener('loadedmetadata', () => {
                video.currentTime = this.videoStart;
                video.play();
            }, { once: true });
        }
    }

    mapTimeStamp(time: string): number {
        const timeString = time;
        const timeParts = timeString.split(':');
        const hours = parseInt(timeParts[0], 10);
        const minutes = parseInt(timeParts[1], 10);
        const seconds = parseInt(timeParts[2], 10);
        const totalSeconds = hours * 3600 + minutes * 60 + seconds;
        return totalSeconds;
    }
}